import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const Hero = styled.header`
    z-index: 0;
    padding: 12em 0 6em 0;
    font-family: ${props => props.theme.font_header};    
    background-color: ${props => 
        props.dark
        ? props.theme.bg_dark
        : props.theme.bg_light
    };
    color: ${props => 
        props.dark
        ? props.theme.font_light
        : props.theme.font_dark
    };
    background-attachment: fixed;
    background-image: 
        url(${props => props.image});
    background-position: top left;
    background-size: cover;
    overflow: hidden;
    position: relative;
    text-align: ${props => 
        props.centered 
        ? 'center'
        : 'left'
    };
    .background {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;

    }
    
    h1 {
        font-size: 3em;
        line-height: 1em;
    }
    p {
        font-size: 1.15em;
        margin: (${props => props.theme.element_margin} * 0.5) 0 0 0;
    }
    .inner {
        opacity: 1;
        position: relative;

        .actions {
            opacity: 1;
        }
    }
    .actions {
        margin: calc(${props => props.theme.element_margin} * 1.25) 0 0 0;
    }
    /* Media queries */
    @media (max-width: 1680px){
        padding: 14em 0 calc(${props => props.theme.element_margin}*2.5) 0;        
    }
    @media (max-width: 1280px){
        padding: 10em 0 calc(${props => props.theme.element_margin}*2.4) 0;                
        br {
            display: inline;
        }
    }
    @media (max-width: 980px){
        font-size: 0.75em;
        padding: 8em 0 calc(${props => props.theme.element_margin}*2.25) 0;                
    }
    @media (max-width: 736px){    
        padding: 6em 0 calc(${props => props.theme.element_margin}*2) 0;
        h1 {
            font-size: 2.5em;
        }
    }
    @media (max-width: 480px) {
            padding: 6em 0 calc(${props => props.theme.element_margin}*2) 0;    
    }
    @media (max-width: 360px) {
        padding: 4em 0 calc(${props => props.theme.element_margin}*2) 0;
    }
`

export { Hero }


// WEBPACK FOOTER //
// ./src/components/hero.js